import Vue from "vue";
import utf8 from 'utf8'; 

const formattedFacturation = function(object) {
  const formattedObj = Object.assign({}, object);
  setEnumerableObj(formattedObj);

  for (let item in formattedObj) {
    formattedObj[item] = formattedObj[item].replace(/\D/g, "");
  }
  return { ...object, ...formattedObj };
};

const setEnumerableObj = function(object) {
  const setEnumerable = { enumerable: false };

  Object.defineProperties(object, {
    razonSocial: setEnumerable,
    apellido: setEnumerable,
    camp: setEnumerable,
    checked: setEnumerable,
    cuit: setEnumerable,
    email: setEnumerable,
    nombre: setEnumerable,
    nombreYApellido: setEnumerable,
    origen: setEnumerable,
    phone: setEnumerable,
    randomKey: setEnumerable,
    telefono: setEnumerable
  });
};

const validateAndNormalizeDocNumber = (numeroDocumento) => {
  if (numeroDocumento.length === 8 && !isNaN(numeroDocumento)) {
    return numeroDocumento;
  } else if (numeroDocumento.length === 7 && !isNaN(numeroDocumento)) {
    return "0" + numeroDocumento;
  } else {
    return null;
  }
};

const getPrefix = (sexo) => {
  const HOMBRE = ["HOMBRE", "M", "MALE"];
  const MUJER = ["MUJER", "F", "FEMALE"];
  const SOCIEDAD = ["SOCIEDAD", "S", "SOCIETY"];

  sexo = sexo.toUpperCase();

  if (HOMBRE.includes(sexo)) {
    return "20";
  } else if (MUJER.includes(sexo)) {
    return "27";
  } else {
    return "30";
  }
};

const calculateCheckDigit = (AB, numeroDocumento) => {
  const multiplicadores = [3, 2, 7, 6, 5, 4, 3, 2];
  let calculo = parseInt(AB[0]) * 5 + parseInt(AB[1]) * 4;

  for (let i = 0; i < 8; i++) {
    calculo += parseInt(numeroDocumento[i]) * multiplicadores[i];
  }

  return calculo % 11;
};

const generateCuil = (AB, numeroDocumento, resto, sexo) => {
  const HOMBRE = ["HOMBRE", "M", "MALE"];
  const SOCIEDAD = ["SOCIEDAD", "S", "SOCIETY"];
  
  let C;

  if (!SOCIEDAD.includes(sexo) && resto === 1) {
    C = HOMBRE.includes(sexo) ? "9" : "4";
    AB = "23";
  } else if (resto === 0) {
    C = "0";
  } else {
    C = (11 - resto).toString();
  }

  return `${AB}${numeroDocumento}${C}`;
};

const cuilGen = (numeroDocumento, sexo) => {
  numeroDocumento = validateAndNormalizeDocNumber(numeroDocumento);

  if (!numeroDocumento) {
    return "";
  }

  const AB = getPrefix(sexo);
  const resto = calculateCheckDigit(AB, numeroDocumento);

  return generateCuil(AB, numeroDocumento, resto, sexo.toUpperCase());
};

const isValidCuil = function(numeroCuit) {
  if (!numeroCuit) {
    return false;
  }

  let cuit = numeroCuit + "";

  if (/^[a-zA-Z]+$/.test(cuit)) {
    // "El campo debe ser numérico";
    return false;
  }

  if (cuit.length !== 11) {
    // Longitud inválida
    return false;
  }

  let acumulado = 0;
  let digitos = cuit.split("");
  let digito = parseInt(digitos.pop());

  for (let i = 0; i < digitos.length; i++) {
    acumulado += parseInt(digitos[9 - i]) * (2 + (i % 6));
  }

  let verif = 11 - (acumulado % 11);
  if (verif === 11) {
    verif = 0;
  }

  let validFormat = digito === verif;
  if (validFormat === false) {
    // Formato inválido
    return false;
  }

  // Formato válido
  return true;
};

const replaceAll = function(str, search, replacement) {
  return str.split(search).join(replacement);
};

const getOrigin = () => {
  const origin = getParameterByName("origen");
  return origin ? origin.toUpperCase() : "OM";
};

const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  const parsedUrl = new URL(url, window.location.origin);
  return parsedUrl.searchParams.get(name);
};

const getTrackingCodeLocal = name => {
  let tc = getParameterByName(name, window.location.href);

  if (tc != null && tc !== "") {
    return tc;
  }
  return null;
};

const obtenerTrackingCode = function() {
  let keys = ["cid", "onsite", "ema", "psm", "dis", "afi", "afl"];
  let tc = "";

  for (let ndx = 0; ndx < keys.length; ndx++) {
    let key = keys[ndx];
    let tccan = getTrackingCodeLocal(key);
    if (tccan !== null) {
      tc = tccan;
      break;
    }
  }

  if (tc === "") {
    return "";
  }

  let tcSplit = "";
  let tcBuild = "";

  if (tc.indexOf(":") === -1) {
    // Tracking codes viejos
    tcSplit = tc.split("-");
  } else {
    // Tracking codes nuevos
    replaceAll(tc, "_", " ");
    tcSplit = tc.split("-")[0].split(":");
  }

  tcBuild =
    tcSplit[0].trim() +
    "-" +
    tcSplit[1].trim() +
    "-" +
    tcSplit[2].trim() +
    "-" +
    tcSplit[3].trim();

  return "-" + tcBuild;
};

const toTitleCase = function(str) {
  if (!!str && str.trim() !== "") {
    return str.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
  return str;
};

const isDev = function() {
  return process.env.NODE_ENV !== "production";
};

const isValidDate = function(dateString) {
  // Verificar patrón
  let regex_date = /\d{2}\/\d{2}\/\d{4}/;

  if (!regex_date.test(dateString)) {
    return false;
  }

  // Parsear string de fecha
  let parts = dateString.split("/");
  let day = parseInt(parts[0], 10);
  let month = parseInt(parts[1], 10);
  let year = parseInt(parts[2], 10);

  // Rango de meses y años
  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
    return false;
  }

  let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Ajustar años biciestos
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
    monthLength[1] = 29;
  }

  // Verificar rango de días
  return day > 0 && day <= monthLength[month - 1];
};

const countSteps = function(pasos) {
  let count = 0;

  for (let key of pasos) {
    if (key.paso) {
      count++;
    }
  }
  return count;
};

const addSeparatorsNF = (nStr, inD, outD, sep, precision = 0) => {
  nStr += "";
  let dpos = nStr.indexOf(inD);
  let nStrEnd = "";
  if (precision) {
    nStr = nStr.slice(0, -precision) + "," + nStr.slice(-precision);
  }
  if (dpos != -1) {
    nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
    nStr = nStr.substring(0, dpos);
  }
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(nStr)) {
    nStr = nStr.replace(rgx, "$1" + sep + "$2");
  }

  return nStr + nStrEnd;
};

//formatea con separador de mil
const formatMoney = amount => {
  let amountInt = parseInt(amount);
  if (!amountInt) {
    return amount;
  }
  let valor = amountInt.toFixed(0);
  valor = addSeparatorsNF(valor, ".", ",", ".");
  return valor;
};

const distanceBetweenCoords = function(lat1, lon1, lat2, lon2) {
  let p = 0.017453292519943295; // Math.PI / 180
  let c = Math.cos;
  let a =
    0.5 -
    c((lat2 - lat1) * p) / 2 +
    (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;

  return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
};

const parseOptions = (sucursales, camp) => {  
  if (!sucursales || !camp) return [];

  if (camp === 'ofertaEmpresa') {
    if ( sucursales.data === undefined 
      || sucursales.data.data === undefined 
      || sucursales.data.data.length === 0
    ) {
      return [];
    }
    
  }  
  return camp === 'ofertaEmpresa' ? parseEmpresas(sucursales) : parseInvididuos(sucursales);
};
const parseInvididuos = (sucursales) => {
  return sucursales.map(item => { 
    return {
      label: item.description ? utf8.decode(item.description) : item,
      value: item.id ? item.id : item,
      provincia: item.address.city ? item.address.city : item,
      localidad: item.address.city ? item.address.city : item,
      direccion: item.address
        ? utf8.decode(item.address)
        : ""
    };
  });
}
const parseEmpresas = (sucursales) => {
  return sucursales.data.data.map(({ description, id, address }) => {
    const decodedDescription = description ? utf8.decode(description) : description;
    const decodedAddress = address && address.addressName ? utf8.decode(address.addressName) : '';

    return {
      label: description && decodedDescription ? decodedDescription : '',
      value: id || '',
      provincia: address && address.city ? address.city : '',
      localidad: address && address.city ? address.city : '',
      direccion: address && decodedAddress ? decodedAddress : '',
    };
  });
}
const confirmarForm = function(recaptchaLoaded, $store, $refs, $log) {
  if (recaptchaLoaded) {
    $store.dispatch('DO_IS_LOADING', true);
    $refs.recaptcha.execute();
  } else {
    $log.error("No se pudo cargar recaptcha");
  }
}

const onCaptchaVerified = function(token, model, $refs, $store, doNext) {
  model.captcha = token;
  $refs.recaptcha.reset();
  $store.dispatch('DO_IS_LOADING', true);
  $store.dispatch(doNext, model);
}

const onCaptchaExpired = function($refs) {
  $refs.recaptcha.reset();
}

export {
  formattedFacturation,
  cuilGen,
  isValidCuil,
  isValidDate,
  getParameterByName,
  getOrigin,
  getTrackingCodeLocal,
  obtenerTrackingCode,
  replaceAll,
  toTitleCase,
  isDev,
  countSteps,
  addSeparatorsNF,
  formatMoney,
  distanceBetweenCoords,
  parseOptions,
  confirmarForm,
  onCaptchaVerified,
  onCaptchaExpired
};
